import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { IconButton } from '@/components/ui/IconButton';
import { usePanelToggle } from '@/features/nav-rail/nav-rail.hooks';
import { inElectron } from '@/utils';

export const WebSidebarToggle = observer(() => {
  const panelToggle = usePanelToggle();

  if (inElectron()) return null;

  return (
    <IconButton
      size="sm"
      icon={panelToggle.opens ? Icons.panelLeftOpen : Icons.panelLeftClose}
      disabled={!panelToggle.available}
      onClick={panelToggle.toggle}
      scale={1.2}
      strokeWidth={1}
      tooltip="Toggle Sidebar"
      tooltipOptions={{ hotkey: 'app.toggleSidebar', side: 'bottom' }}
    />
  );
});
